import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
// 设置文件
import setting from '@/setting.js';
export default (function (context) {
  return {
    namespaced: true,
    state: {
      // 是否开启页面过度动画
      active: setting.transition.active
    },
    actions: {
      /**
       * @description 设置开启状态
       * @param {Object} vuex context
       * @param {Boolean} active 新的状态
       */
      set: function set(_ref, active) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var state, dispatch;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  state = _ref.state, dispatch = _ref.dispatch;
                  // store 赋值
                  state.active = active; // 持久化

                  _context.next = 4;
                  return dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'transition.active',
                    value: state.active,
                    user: true
                  }, {
                    root: true
                  });

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      },

      /**
       * 从数据库读取页面过渡动画设置
       * @param {Object} vuex context
       */
      load: function load(_ref2) {
        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var state, dispatch;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  state = _ref2.state, dispatch = _ref2.dispatch;
                  _context2.next = 3;
                  return dispatch('d2admin/db/get', {
                    dbName: 'sys',
                    path: 'transition.active',
                    defaultValue: setting.transition.active,
                    user: true
                  }, {
                    root: true
                  });

                case 3:
                  state.active = _context2.sent;

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))();
      }
    }
  };
});